import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl, springBaseUrl } from '../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import Footer from '../components/Footer';
import { saveCartEarlyCheckin, saveEarlyCheckinnSlot } from '../redux/slice/slice';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import MainSkeleton from '../skeletons/MainSkeleton';
import CheckinSkeleton from '../skeletons/CheckinSkeleton';
import { encryptBookingId } from '../utils/CryptoHashing';

const Cancellation = () => {
  const navigate = useNavigate();
  const hotelId = useSelector(state => state?.HotelId);
  const HomepageData = useSelector(state => state?.HomepageData);
  const SummaryData = useSelector(state => state?.SummaryData);
  const currencySymbol = useSelector(state => state?.Currency);
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);
  const [cancelLoader, setCancelLoader] = useState(false);

  const [cancelCharges, setCancelCharges] = useState({});
  const handleRefundCharges = () => {
    axios
      .get(
        `${baseUrl}/api/v2/payments/refundPayment/?booking_id=${encodeURIComponent(
          encryptBookingId(HomepageData?.booking?.bookingId)
        )}&amount=${cancelCharges?.refundAmt}&logged_user_email=${
          HomepageData?.booking?.userEmail
        }&hotelId=${hotelId}&hotel_id=${hotelId}&source=${'magic_link'}&hash=${encodeURIComponent(localStorage.getItem("bookingHash") || '')}`
      )
      .then(() => {
        setCancelLoader(false);
        navigate('/cancellation-status', {
          state: { cancelCharges: cancelCharges },
        });
      })
      .catch(() => {
        setCancelLoader(false);
      });
  };

  const handleCancelBooking = () => {
    setCancelLoader(true);
    const payload = {
      bookingId: encryptBookingId(HomepageData?.booking?.bookingId),
    };
    axios
      .post(`${springBaseUrl}/core/api/v1/ss/cancel-booking`, {...payload, hash: encodeURIComponent(localStorage.getItem("bookingHash") || '')})
      .then(() => {
        if (cancelCharges?.refundAmt > 0) {
          handleRefundCharges();
        } else {
          setCancelLoader(false);
          navigate('/cancellation-status', {
            state: { cancelCharges: cancelCharges },
          });
        }
      })
      .catch(() => {
        setCancelLoader(false);
      });
  };

  useEffect(() => {
    setLoader(true);
    axios
      .get(
        `${baseUrl}/web-api/get-magic-link-cancel-charges?hotelId=${hotelId}&bookingId=${HomepageData?.booking?.bookingId}&hash=${encodeURIComponent(localStorage.getItem("bookingHash") || '')}`
      )
      .then(res => {
        setLoader(false);
        setCancelCharges(res.data);
      })
      .catch(() => {
        setLoader(false);
      });
  }, []);

  return (
    <>
      {loader ? (
        <CheckinSkeleton />
      ) : (
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <IconButton
              sx={{ backgroundColor: '#3D3D3D4D' }}
              onClick={() => {
                window.history.back();
              }}
            >
              <KeyboardArrowLeftIcon sx={{ color: '#FFFFFF', fontSize: 24, strokeWidth: 2 }} />
            </IconButton>
            <Typography sx={{ fontSize: 24, fontWeight: 900 }} color="text.gray">
              Do you want to cancel the booking?
            </Typography>
          </Box>

          <Box
            sx={{
              mt: 5,
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}
          >
            <Box>
              <Card
                sx={{
                  backgroundColor: '#3D3D3D4D',
                  borderRadius: '20px',
                  p: '12px',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 16, fontWeight: 400 }} color="text.secondary">
                    Refund amount
                  </Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
                    {currencySymbol} {cancelCharges?.refundAmt}
                  </Typography>
                </Box>
              </Card>
            </Box>
            {/* <Box sx={{ width: "100%" }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={voidType}
                fullWidth
                onChange={(e) => setVoidType(e.target.value)}
                sx={{
                  color: "white",

                  borderRadius: "28px",
                  border: "1px solid white",
                  "& .MuiSelect-icon": {
                    color: "white",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: "rgba(0, 0, 0, 0.8)",
                      "& .MuiMenuItem-root": {
                        color: "white",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.2)",
                        },
                      },
                    },
                  },
                }}
              >
                {voidTypeOptions.map((option, idx) => (
                  <MenuItem key={idx} value={option.name}>
                    {option.description}
                  </MenuItem>
                ))}
              </Select>
            </Box> */}

            {/* Footer with Proceed Button */}
            <Footer>
              <Button
                fullWidth
                variant="light-button"
                onClick={handleCancelBooking}
                disabled={cancelLoader}
              >
                Yes, cancel {cancelLoader && <CircularProgress size={20} sx={{ color: '#FFF' }} />}
              </Button>
            </Footer>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Cancellation;
